"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LUX_LOYALTY_LUX_PLUS_ELIGIBLE_RENEWAL_BONUS_ID = exports.LUX_LOYALTY_POINTS_PER_STATUS_CREDIT = void 0;
/**
 * The number of points per status credit. Business directive is that this value is 1000/17
 */
exports.LUX_LOYALTY_POINTS_PER_STATUS_CREDIT = 58.8235294117647;
/**
* @dev this is the id to append to the offerId for the renewal bonus which should be
* used if a customer is within the renewal grace period
*/
exports.LUX_LOYALTY_LUX_PLUS_ELIGIBLE_RENEWAL_BONUS_ID = 'lux-plus-renewal-bonus';
